import React, { useEffect, useState } from 'react';
import demographicStyles from "./Demographics.module.scss"
import styles from '../../pages/orders-module/OrdersDetails/OrdersDetails.module.scss';
import { LineOfBusinessEnum } from '../../constants/BusinessConstants';
import { Button, Chip, Link, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DischargeReason, GenderEnum, OrderDetailsPatientEnum } from '../../common/enums';
import { EMRTooltip } from '../MuiCustomComponent/MuiCustomComponent';

import { commonConstants } from '../../common/constants';
import { useSelector } from 'react-redux';
import { CustomFieldDetails } from '../../common/customFields/CustomFieldDetails';
import { handlePatientCustomFields } from '../../common/CustomFieldHelperFunctions/CustomFieldHelperFunctions';
import ItemLabel from '../ItemLabel/ItemLabel';
import StatusBadge from '../StatusBadge/StatusBadge';
import Icon from '../Icon/Icon';
import Panel from '../Panel/Panel';

const Demographics = ({ title, patientInformation, hasOtherOrder, orderId, branchId = 0, patientId = null, ...panelProps }) => {
  const { t } = useTranslation();
  const [patientInfo, setPatientInfo] = useState(patientInformation);
  const [patientCustomFields, setPatientCustomFields] = useState([])
  const [emrField, setEmrField] = useState(null);
  const companyId = useSelector((state) => state.authState.userData?.data?.company_settings[0]?.company_id ?? 0);
  const navigate = useNavigate();
  const handleViewOtherOrderPage = (id) => {
    localStorage.setItem("drawerSelectedItem", "Orders");
    navigate("/view-other-orders/" + id);
  };

  useEffect(() => {
    if (patientInformation?.patient_id && companyId) {
      handlePatientCustomFields(setPatientCustomFields, setEmrField, branchId, companyId, patientInformation?.patient_id)
    }
  }, [patientInformation?.patient_id, companyId])

  return (
    <Panel data-testid="Demographics" title={title} {...panelProps}>
      {patientId && (
        <Stack direction="row" spacing={3} sx={{ alignItems: "center", mb: 3 }}>
          <Link
            component={RouterLink}
            to={`/${LineOfBusinessEnum.patientsToMembers.toLowerCase()}/${LineOfBusinessEnum.patientToMember.toLowerCase()}-details/${patientId}`}
            onClick={(e) => e.stopPropagation()}
            variant='h5'
          >
            {patientInfo?.patient_last_name}, {patientInfo?.patient_first_name} {patientInfo?.patient_middle_initial}
          </Link>
          <Stack direction="row" spacing={2}>
            <StatusBadge
              status={OrderDetailsPatientEnum[patientInfo?.patient_status]}
            />
            {patientInfo?.emr_integration_flag && (
              <EMRTooltip
                title={<span className={styles.tooltipStyling}>{t("PatientDetails.EMRdescription")} </span>}
                placement="right"
              >
                <StatusBadge
                  label={t("PatientDetails.EMR")}
                />
              </EMRTooltip>
            )}
          </Stack>
        </Stack>
      )}
      <Stack spacing={1}>
        {patientInfo?.patient_id && (
          <ItemLabel label={t("PatientsListing.dmeTrackId")} text={patientInfo?.patient_id} />
        )}
        {patientInfo?.mrn && (
          <ItemLabel label={emrField?.display_name ?? t("PatientsListing.mrn")} text={patientInfo?.mrn} />
        )}
        {LineOfBusinessEnum.patientToMember?.toLocaleLowerCase() == "member" && patientInfo?.sex && (
          <ItemLabel label={t("PatientsDetails.sex")} text={GenderEnum[patientInfo?.sex]} />
        )}
        {(patientInfo?.date_of_birth !== commonConstants.defaultDate && patientInfo?.date_of_birth) && (
          <ItemLabel label={t("PatientsDetails.dateOfBirth")} text={patientInfo?.date_of_birth} />
        )}
        {patientInfo?.admission_date && patientInfo?.admission_date !== commonConstants.defaultDate && (
          <ItemLabel label={t("PatientsDetails.admissionDate")} text={patientInfo?.admission_date?.split(" ")[0]} />
        )}
        {patientInfo?.height && (
          <ItemLabel label={t('AddPatient.height')} text={patientInfo?.height} />
        )}
        {patientInfo?.weight && (
          <ItemLabel
            label={t('AddPatient.weight')}
            text={patientInfo?.weight.includes("lbs") ? patientInfo?.weight.replace("lbs", "") + " lbs" : patientInfo?.weight + " lbs"}
          />
        )}
        {patientInfo?.discharge_date && !patientInfo?.discharge_date.includes(commonConstants.defaultDate) && (
          <ItemLabel label={t("PatientsListing.dischargeDate")} text={patientInfo?.discharge_date} />
        )}
        {patientInfo?.discharge_reason !== " " && patientInfo?.discharge_reason && (
          <ItemLabel label={t("PatientsDetails.dischargeReason")} text={DischargeReason[patientInfo?.discharge_reason]} />
        )}
        {patientCustomFields?.length > 0 && <CustomFieldDetails customFieldData={patientCustomFields} />}
      </Stack>
      {hasOtherOrder && (
        <Button
          variant='tertiary'
          onClick={() => handleViewOtherOrderPage(orderId)}
          sx={{ display: 'flex', alignItems: 'center', width: 'fit-content', ml: 'auto' }}
        >
          {t('PatientsDetails.viewOtherOrder')}
          <Icon icon="fa-chevron-right" size='tiny' />
        </Button>
      )}
    </Panel>)
}


export default Demographics;
